import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import { COLORS } from "constants/colors";
import AppLayout from "works/chi/components/AppLayout";
import StyledButton from "works/chi/components/StyledButton";
import ButtonDialog from "default/components/ButtonDialog";
import { shortenTicket } from "utils/api";

// Legacy Chi migration screen. This was temporarily needed during the early
// ticket-duration migration and is no longer linked from the normal MyPage flow.
function ShortenTicket() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [openComplete, setOpenComplete] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);

  const soulId = queryParams.get("soul_id");

  const handleClickConfirm = async () => {
    setIsProcessing(true);
    // api呼び出し
    try {
      await shortenTicket(soulId);
    } catch (error) {
      setIsProcessing(false);
      setOpenConfirm(false);
      setOpenError(true);
      return;
    }
    setIsProcessing(false);
    setOpenConfirm(false);
    setOpenComplete(true);
  };

  const navigateToMyPage = () => {
    navigate(`/chi/mypage?soul_id=${soulId}`);
  };

  const handleConfirmClose = () => {
    setOpenConfirm(false);
  };

  const handleShorten = () => {
    setOpenConfirm(true);
  };

  return (
    <AppLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: COLORS.BACKGROUND_WHITE,
            borderRadius: "5px",
            padding: 4,
            gap: 4,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "15px",
              whiteSpace: "pre-line",
              fontWeight: "bold",
              textAlign: "center",
              color: COLORS.TEXT_BLACK,
              mt: 1,
            }}
          >
            {"変更時の残り日数は\n下記のように変更されます"}
          </Typography>

          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: "16px",
                whiteSpace: "pre-line",
                // fontWeight: "bold",
                textAlign: "center",
                color: "#EB8010", // 落ち着いたオレンジ文字
                backgroundColor: "#FFF9EE", // 薄オレンジ背景
                border: "1px solid #FFD591", // 枠線もやさしめ
                borderRadius: "6px",
                padding: "10px 14px",
                lineHeight: "1.6",
                mt: 1,
              }}
            >
              {
                "残り日数の換算\n\n旧残り日数 → 新残り日数\n26〜28日 → 8日\n23〜25日 → 7日\n20〜22日 → 6日\n15〜19日 → 5日\n12〜14日 → 4日\n9〜11日 → 3日\n6〜8日 → 2日\n3〜5日 → 1日\n1〜2日 → 変更不可"
              }
            </Typography>
          </Box>

          <StyledButton
            variant="contained"
            sx={{
              width: "70%",
              fontSize: "17px",
              color: COLORS.TEXT_BLACK,
              border: `2px solid ${COLORS.TEXT_BLACK}`,
            }}
            onClick={handleShorten}
          >
            プランを変更
          </StyledButton>
        </Box>

        <ButtonDialog
          open={openConfirm}
          title={`短縮プランに切り替えますか？`}
          // buttons={[{"label": "短縮する", "onClick": handleClickConfirm}]}
          rawButtons={[
            <StyledButton
              variant="contained"
              sx={{
                width: "70%",
                fontSize: "17px",
                color: COLORS.TEXT_BLACK,
                border: `2px solid ${COLORS.TEXT_BLACK}`,
              }}
              onClick={handleClickConfirm}
              disabled={isProcessing}
            >
              切り替える
            </StyledButton>,
          ]}
          handleClose={handleConfirmClose}
        />

        <ButtonDialog
          open={openError}
          title={`プランの変更に失敗しました`}
          description={"時間を置いてからもう一度お試しください"}
          buttons={[
            {
              label: "閉じる",
              onClick: () => {
                setOpenError(false);
              },
            },
          ]}
          handleClose={() => {
            setOpenError(false);
          }}
        />

        <ButtonDialog
          open={openComplete}
          title={`プランを切り替えました`}
          buttons={[{ label: "マイページへ", onClick: navigateToMyPage }]}
          handleClose={() => {
            setOpenComplete(false);
          }}
        />
      </Box>

      {/* <Loading /> */}
    </AppLayout>
  );
}

export default ShortenTicket;
